/**
 * Autopromo slider
 */
(function($) {
    "use strict";

    // Get the modal
    var modal = $('#mymodal');

    // Get the button that opens the modal
    var btn = $('.field--name-field-titre-bouton');

    // Get the <span> element that closes the modal
    var span = $('.close');

    // When the user clicks on the button, open the modal
    // btn.onclick = function() {
    //     modal.style.display = "block";
    // }
    btn.click(function() {
        modal.css("display","block");
    });

    // When the user clicks on <span> (x), close the modal
    span.click(function() {
        modal.css("display","none");
    });

    // When the user clicks anywhere outside of the modal, close it
    $(window).click(function(event) {
         if (modal.is(event.target)) {
            modal.css("display","none");
        }
    });


    // var modalCrm = $('.modal');
    $(document).on("click", ".field--cta-crm", function (e) {
        $(this).parent().find(".modal").css("display","block");
    });

    $(window).click(function(event) {
        if ($('.modal').is(event.target)) {
          $('.modal').css("display","none");
        }
    });


})(jQuery);